<template>
  <v-container fluid grid-list-md>
    <v-card class="pa-2 mb-4">
      <v-tooltip :disabled="canCreate" bottom>
        <v-btn
          slot="activator"
          :disabled="!canCreate"
          @click="openIdeaSpaceEditor"
          color="primary">
          {{ $vuetify.t('$vuetify.AdminIdeaSpace.add') }}
        </v-btn>
        <span>{{ $vuetify.t('$vuetify.Permissions.noPermission') }}</span>
      </v-tooltip>
    </v-card>
    <v-card class="pa-3 mb-2">
      <TableSearchBar
        @changed="searchChanged">
      </TableSearchBar>
      <v-data-table
        :headers="headers"
        :items="ideaSpaces"
        :search="search"
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.description }}</td>
          <td class="justify-start">
            <v-icon v-if="canEdit"
                    class="mr-2"
                    small
                    @click="editIdeaSpace(props.item)">
              edit
            </v-icon>
            <v-icon v-if="canDelete"
                    small
                    @click="openDeleteIdeaSpaceDialog(props.item)">
              delete
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <FileSizeUploadErrorDialog ref="fileSizeUploadErrorDialog"></FileSizeUploadErrorDialog>
    <v-dialog v-model="ideaSpaceCreationDialog" max-width="750px">
      <v-card>
        <v-card-text>
          <v-layout column wrap>
            <v-flex d-flex xs12 sm12 pa-2>
              <v-text-field
                name="title"
                v-model="newIdeaSpace.title"
                v-validate="'required'"
                :label="this.$vuetify.t('$vuetify.AdminIdeaSpace.formIdeaSpaceName')"
                required
                :rules="[() => newIdeaSpace.title.length > 0 || this.$vuetify.t('$vuetify.inputRequired')]"
              ></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm12 pa-2>
              <v-text-field
                name="description"
                v-model="newIdeaSpace.description"
                v-validate="'required'"
                :label="this.$vuetify.t('$vuetify.AdminIdeaSpace.formIdeaSpaceDescription')"
                required
                :rules="[() => newIdeaSpace.description.length > 0 || this.$vuetify.t('$vuetify.inputRequired')]"
              ></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm12 pa-2>
              <v-text-field
                name="slug"
                v-model="slug"
                v-validate="'required'"
                readonly
                disabled
                :label="this.$vuetify.t('$vuetify.AdminIdeaSpace.formIdeaSpaceUrlName')"
                required
              ></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm12 pa-2>
              <v-layout row wrap>
                <v-flex class="ideaSpaceImage-button" :class="{ selectedImage: image === newIdeaSpace.image }" pa-2
                        v-for="(image, index) of defaultIdeaSpacesImages" :key="index">
                  <v-img :src="image" height="100" width="200" @click="selectImage(image)"/>
                </v-flex>

              </v-layout>
            </v-flex>
            <v-flex>
              <v-img :contain="true" :src="newIdeaSpace.image" height="100" width="200"
                     v-if="defaultIdeaSpacesImages.indexOf(newIdeaSpace.image) < 0"/>
              <vue-base64-file-upload
                accept="image/png,image/jpeg,image/svg"
                image-class="upload-image-preview"
                input-class="upload-image-input"
                :placeholder="$vuetify.t('$vuetify.Form.picture')"
                :max-size="maxImageFileSize"
                @size-exceeded="onSizeExceeded"
                @load="onLoad"/>
            </v-flex>
            <v-flex d-flex xs12 sm12 pa-2>
              <v-btn
                @click="addIdeaSpace"
                color="primary"
                :disabled="!isValid">
                {{ $vuetify.t('$vuetify.Form.save') }}
              </v-btn>
              <v-btn
                @click="ideaSpaceCreationDialog = false">
                {{ $vuetify.t('$vuetify.AdminUsers.formCancel') }}


              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <IdeaSpaceDeleteDialog
      v-if="showDeleteDialog"
      :show="showDeleteDialog"
      :ideaSpace="toDelete"
      @handleClose="showDeleteDialog = false"
      @handleSuccess="closeDeleteIdeaSpaceDialog(true)"
      @handleError="closeDeleteIdeaSpaceDialog(false)"/>
  </v-container>
</template>

<script>

import api from '@/api'
import slugify from 'slugify'
import VueBase64FileUpload from 'vue-base64-file-upload'
import FileSizeUploadErrorDialog from './dialogs/FileSizeUploadErrorDialog'
import TableSearchBar from '@/components/util/TableSearchBar'
import IdeaSpaceDeleteDialog from './dialogs/IdeaSpaceDeleteDialog'

export default {
  $_veeValidate: {validator: 'new'},
  name: 'IdeaSpacesAdmin',
  components: {
    IdeaSpaceDeleteDialog,
    TableSearchBar,
    FileSizeUploadErrorDialog,
    VueBase64FileUpload
  },
  data: function () {
    return {
      headers: [
        {
          text: this.$vuetify.t('$vuetify.AdminIdeaSpace.formIdeaSpaceName'),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminIdeaSpace.formIdeaSpaceDescription'),
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: 'Actions',
          align: 'left',
          value: null,
          sortable: false
        }
      ],
      ideaSpaces: [],
      ideaSpaceCreationDialog: false,
      ideaSpaceDeleteDialog: false,
      isEditing: false,
      defaultIdeaSpacesImages: ['./static/img/svg/door1.svg', './static/img/svg/door2.svg', './static/img/svg/door3.svg', './static/img/svg/door4.svg'],
      newIdeaSpace: {
        school_id: this.$store.getters.selected_school,
        title: '',
        description: '',
        image: './static/img/svg/door1.svg',
        imagecontain: false
      },
      maxImageFileSize: 2, // in mb
      search: '',
      showDeleteDialog: false,
      toDelete: null
    }
  },

  computed: {
    canCreate: function () {
      return this.$hasPermission(this.$permissions.idea_space.items.createRoom)
    },
    canEdit: function () {
      return this.$hasPermission(this.$permissions.idea_space.items.editRoom)
    },
    canDelete: function () {
      return this.$hasPermission(this.$permissions.idea_space.items.deleteRoom)
    },
    slug: function () {
      return slugify(this.newIdeaSpace.title)
    },
    isValid () {
      return this.newIdeaSpace.title && this.newIdeaSpace.title.length > 0 &&
        this.newIdeaSpace.description && this.newIdeaSpace.description.length > 0 &&
        this.slug && this.slug.length > 0
    }
  },

  beforeMount: function () {
    this.getIdeaSpaces()
  },

  methods: {
    openDeleteIdeaSpaceDialog (toDelete) {
      this.toDelete = toDelete
      this.showDeleteDialog = true
    },
    closeDeleteIdeaSpaceDialog (successful) {
      this.toDelete = null
      this.showDeleteDialog = false
      this.getIdeaSpaces()
    },
    searchChanged: function (value) {
      this.search = value
    },
    openIdeaSpaceEditor: function () {
      this.newIdeaSpace = {
        school_id: this.$store.getters.selected_school,
        title: '',
        image: '/static/img/svg/door1.svg'
      }

      this.ideaSpaceCreationDialog = true
    },

    onLoad: function (dataUri) {
      this.newIdeaSpace.image = dataUri
      this.newIdeaSpace.imagecontain = true
    },

    getIdeaSpaces: function () {
      api.ideaSpace.getIdeaSpaces(this.$store.getters.selected_school).then(response => {
        this.ideaSpaces = response.data
      })
    },
    addIdeaSpace: function () {
      if (!this.isEditing) {
        this.newIdeaSpace.created_by = this.$store.getters.userId
        this.newIdeaSpace.slug = this.slug
        api.ideaSpace.createIdeaSpace(this.newIdeaSpace).then(() => {
          this.getIdeaSpaces()
          this.ideaSpaceCreationDialog = false
        })
      } else {
        this.newIdeaSpace.slug = this.slug
        api.ideaSpace.updateIdeaSpace(this.newIdeaSpace).then(() => {
          this.getIdeaSpaces()
          this.ideaSpaceCreationDialog = false
        })
      }
    },
    editIdeaSpace: function (ideaSpace) {
      this.isEditing = true
      this.newIdeaSpace = ideaSpace
      this.ideaSpaceCreationDialog = true
    },
    selectImage: function (image) {
      this.newIdeaSpace.image = image
      this.newIdeaSpace.imagecontain = false
    },
    submit: function () {
    },
    onSizeExceeded (size) {
      this.$refs.fileSizeUploadErrorDialog.show(size)
    }
  }
}
</script>

<style lang="scss">
.ideaSpaceImage-button {
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 4px;

  &.selectedImage {
    border: 2px solid var(--v-secondary-base);
  }
}

</style>
